import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { homepageTools } from "../data/tools";
import { SEO } from "../components/SEO";
import { homeMeta } from "../seo/meta";

export function HomePage() {
  const { t } = useTranslation();

  return (
    <>
      <SEO {...homeMeta(t("hero.metaDescription"))} />
      <main className="content" id="top">
      <section className="hero">
        <div className="hero-pill">{t("hero.pill")}</div>
        <h1 className="hero-title">
          {t("hero.title")} <span>{t("hero.highlight")}</span>
        </h1>
        <p className="hero-subtitle">
          {t("hero.subtitle")}
        </p>
        <div className="hero-actions">
          <Link to="/tools" className="button button-primary">
            {t("hero.explore")}
          </Link>
        </div>
      </section>

      <section className="tools-section" id="tools">
        <h2 className="section-title">{t("tools.sectionTitle")}</h2>
        <p className="section-subtitle">
          {t("tools.sectionSubtitle")}
        </p>
        <div className="tools-grid">
          {homepageTools.map((tool) => (
            <Link
              key={tool.slug}
              to="/tools/$toolSlug"
              params={{ toolSlug: tool.slug }}
              className="tool-card"
            >
              <div className="tool-icon">
                <tool.Icon className="tool-icon-svg" aria-hidden="true" />
              </div>
              <h3>{t(`${tool.i18nKey}.name`)}</h3>
              <p>{t(`${tool.i18nKey}.description`)}</p>
              <span className="tool-link">{t("tools.useTool")}</span>
            </Link>
          ))}
        </div>
      </section>
    </main>
    </>
  );
}
